import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Box, Stack, Typography } from '@lyearn/ui';
import { Image } from '@/components/Image';

import { useDesignContext } from '../../context/Design';
import { DesignCard } from '../../enums';
import UnsplashFooter from '../UnsplashFooter';
import { coverImageStyles } from './styles';
import { PreviewProps } from './types';

const Preview: React.FC<PreviewProps> = (props) => {
  const { className } = props;
  const { previewCover, overlayContent, contentName, contentAuthor } = useDesignContext();

  const { t } = useTranslation();

  if (overlayContent.type === DesignCard.None) {
    return null;
  }

  return (
    <Stack
      alignItems="center"
      className={cn('flex-1', className)}
      direction="col"
      justifyContent="center">
      {previewCover.url ? (
        <Image
          alt="content cover"
          className="absolute h-full w-full"
          layout="fill"
          src={previewCover.url}
        />
      ) : null}
      <Box className={cn('absolute h-full w-full', coverImageStyles)} />
      <Stack alignItems="center" className="absolute" direction="col" gapY={16}>
        <Typography className="text-center" color="text-text-white" variant="display-xxxl">
          {contentName}
        </Typography>
        <Typography color="text-text-white" variant="heading-s">
          {contentAuthor ? t('Common:Design.By', { person: contentAuthor }) : null}
        </Typography>
      </Stack>
      <Stack alignItems="center" className="absolute bottom-0 w-full" justifyContent="center">
        {previewCover.authorName ? (
          <UnsplashFooter
            authorLink={previewCover.authorProfileLink}
            authorName={previewCover.authorName}
          />
        ) : null}
      </Stack>
    </Stack>
  );
};

export default Preview;
